
import React from "react";
import {ITechSpecsTab} from "../interfaces";
import {GetH1} from "../../../custom-pages/product-course/crs-outline/src-outline-helper";


export interface ITechSpecsTabProps {
    techSpecsTab?: ITechSpecsTab;
    majorVersion?: string;
    hideVersion?: boolean;
}
/**
 * the entry point
 */
const TabTitle = (props?: ITechSpecsTabProps) => {

    const techSpecsTab = props?.techSpecsTab;
    const majorVersion = props?.majorVersion;
    const tabName = techSpecsTab ? techSpecsTab?.tabName  : 'Sample Rate & Latency';

    return (
        <div className="my-4">
            {
                <div className="text-xl text-gray-700"><span className="hidden md:inline-block"><span className="font-bold">{GetH1()}</span> { !props?.hideVersion && <span>(V{majorVersion})</span> } - </span> {tabName}</div>
            }
        </div>
    )
};

export default TabTitle;